export const SET_CATEGORIES = 'set-categories';
export const CLEAR_CATEGORIES = 'clear-categories';
